module.exports = __webpack_public_path__ + "img/orCode.608d038c.png";